import { applyMiddleware, createStore, compose } from "redux";
import thunkMiddleware from "redux-thunk";
// import { createLogger } from 'redux-logger';
import rootReducer from "src/redux/reducers";

// const loggerMiddleware = createLogger();

export default function configureStore(preloadedState = {}) {
  const middlewares = [thunkMiddleware]; // loggerMiddleware
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = compose(...enhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  return store;
}
